import { apiPost } from '@/features/shared/utils/dataFetching'
import { type AvailablePromotionsResponse } from '@/features/shop/services/Campaigns/types'
import { normalizeCampaignsResponse } from '@/features/shop/services/Campaigns/utils'
import { type AvailablePromoQueryKey } from '@/features/shop/services/Campaigns/queries'
import { type QueryFunctionContext } from '@tanstack/react-query'

export const fetchAvailablePromotions = async (
  context: QueryFunctionContext<AvailablePromoQueryKey>,
) => {
  const [, { currentOrderId, storeParams }] = context.queryKey
  const { store_id, store_location_id, metro_id } = storeParams
  const promotions = await apiPost<AvailablePromotionsResponse>({
    config: {
      url: 'campaigns/v1/promotions/available',
      data: {
        context: {
          all: {
            store_id: String(store_id),
            metro_id: String(metro_id),
            store_location_id: String(store_location_id),
          },
        },
        ...(currentOrderId && {
          identifier: {
            order: {
              id: `${currentOrderId}`,
            },
          },
        }),
      },
    },
    context,
    fetcherName: 'fetchAvailablePromotions',
  })
  return normalizeCampaignsResponse(promotions.promotions || [])
}
